// eslint-disable-next-line @openclassrooms/classify-styled
import type { Breakpoint } from '@mui/material/styles';
import { breakpointsOrdered } from '../Theme/breakpoints';

function getValueForCurrentBreakpoint(
  valuesPerBreakpoints: { [breakpoint in Breakpoint]?: any },
  currentBreakpoint: Breakpoint
): any {
  const startIndex = breakpointsOrdered.indexOf(currentBreakpoint);
  for (let i = startIndex; i >= 0; i -= 1) {
    const breakpoint = breakpointsOrdered[i];
    if (valuesPerBreakpoints[breakpoint] !== undefined) {
      return valuesPerBreakpoints[breakpoint];
    }
  }

  return undefined;
}

export default getValueForCurrentBreakpoint;
